<ng-container *ngIf="!field.multiple">
    <div [formGroup]="group">
        <mat-checkbox
            (click)="$event.stopPropagation()"
            [class]="field.class"
            [formControl]="group?.get(field?.name)"
            [disableRipple]="true">
            {{field.label + (field.required ? ' *' : '')}}
        </mat-checkbox>
    </div>
</ng-container>
<ng-container *ngIf="field.multiple">
    <mat-form-field class="!hidden" appearance="outline" [formGroup]="group">
        <input matInput [formControlName]="field.name" readonly>
    </mat-form-field>
    <div class="checkbox-label-text" *ngIf="field.label"><label>{{field.label}}</label>
    </div>
    <div *ngFor="let item of field.options; let index = index">
        <mat-checkbox [disabled]="field.disabled"
                      (click)="$event.stopPropagation()"
                      (change)="changeCheckbox($event, (field.optionsName ? item[field.optionsName] : item.value))"
                      [checked]="selection.isSelected(field.optionsName ? item[field.optionsName] : item.value)">
            {{item.name}}
        </mat-checkbox>
    </div>
</ng-container>

